import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from "@/store/userStore"; // Import the user store

const routes = [
  {
    path: "/",
    redirect: () => {
      // Redirect logic will be handled in a navigation guard
      return "/home";
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/NotFound.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => { 
  // Detect startup error
  if (window.__APP_STARTUP_ERROR__) {
    // Optionally redirect to a dedicated error route, or just abort navigation
    if (to.path !== '/') {
      return next('/');
    }
    return next();
  }
  const userStore = useUserStore();
  const isLoggedIn = userStore.isLoggedIn();
  const defaultTitle = "NORD";
  document.title = to.name ? `${defaultTitle} - ${to.name}` : defaultTitle;
  let isIframe = false;
  if(to.meta?.page?.iframe){
    isIframe = to.meta.page.iframe == "true";
  }
  let foundPage = to.matched.find((route) => route.name !== "NotFound");
  // if not found page and is not logged in, redirect to login
  if (!foundPage && !isLoggedIn && !isIframe) {
    // If the user is not logged in and trying to access a route other than /login, redirect to /login
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next("/login");
  } else {
    next();
  }
});

export default router;